export default function getAllEncartsById(produit, ids) {
  if (!produit.produitPresse) return null;
  const result = produit.produitPresse.encarts.filter((ligne) => {
    return ids.includes(ligne.id);
  });
  if (result.length === 0) {
    return null;
  }
  return result[0];
}
